import React from 'react';
import HighmapsWrapper from 'components/highmapsWrapper';

const WorldSnapshotMap = () => (
  <HighmapsWrapper type="world" />
);

export default WorldSnapshotMap;



// WEBPACK FOOTER //
// ./app/components/worldSnapshotMap/index.js